export default Object.freeze({
  Gray: 'gray',
  GreenLight: 'green-light',
  Red: 'primary-4',
  Yellow: 'yellow',
});
